module.exports = __webpack_public_path__ + "static/media/alpha_logo.a52e8f50.png";